import type { Campaign } from './campaignsApi';
import { campaignTextList } from './campaignJourney';

export interface GoogleProposals {
  headlines: string[];
  descriptions: string[];
  keywords: string[];
}

export interface GoogleProposalResult {
  ok: boolean;
  campaignId: string;
  google_ads: GoogleProposals;
}

export function campaignGoogleProposals(campaign: Campaign): GoogleProposals {
  return { headlines: campaignTextList(campaign.google_headlines),
    descriptions: campaignTextList(campaign.google_descriptions),
    keywords: campaignTextList(campaign.google_keywords) };
}
